import {noop} from '@sail/utils';
import {createContext} from 'react';

import type {PerformanceMonitorTrackStop} from 'src/types';

export default createContext<PerformanceMonitorTrackStop>(noop);
